import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTableBody, MDBTable, MDBTableHead,MDBIcon } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

const date = new Date();
const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
const dates = year+"-"+month+"-"+day ;

export default class ModelcuNotApprove extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        Curriculumopen_ID :'',
        Course_ID :'',
        Course_YEAR :'',
        Curriculumopen_TEAM :'',
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_Detail_TH:'',
        Curriculumopen_Detail_EN:'',
        Curriculumopen_CH:'',
        Curriculumopen_Date_START:'',
        Curriculumopen_Date_END:'',
        Univ_ID:'',
        plan:[],

        comment:'',
        Approve:'3',

        
      }

this.handleChangnot = this.handleChangnot.bind(this);
this.updatenotApprove = this.updatenotApprove.bind(this);

}


toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChangnot(event) {    this.setState({comment: event.target.value});  }

  updatenotApprove() {
    // alert('A name was submitted: ' + this.state.value);
   // console.log(e.target.value)
   if (this.state.comment !='') {
        const id = this.props.Curriculumopen_ID;
                setTimeout(() => {
                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                    datafrm.append("Curriculumopen_ID", id);
                    datafrm.append("Approve", this.state.Approve);
                    datafrm.append("comment", this.state.comment);
                    datafrm.append("date", dates);
                    
                    
                    api.post("index/updateNotApprove/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    })

                    .then(res => {
                    //    console.log(res);
                        if (res.status === 200) {
                        //  alert("บันทึกสำเร็จ")
                                Swal.fire({
                                    title: 'ยืนยันการพิจารณาสำเร็จ',
                                    icon: 'success',
                                    // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                    // cancelButtonText: 'No, keep it'
                                    }).then((result) => {
                                    
                                    })
                                }
                        })
                      this.toggle()

                      this.props.getApprovecu()
                    //  this.getplan();
                }, 1000);
   } else {

        Swal.fire({
        title: 'กรุณาเพิ่มข้อเสนอแนะ/ความคิดเห็น',
        icon: 'warning',
        // showCancelButton: true,
        confirmButtonText: 'ตกลง',
        // cancelButtonText: 'No, keep it'
        }).then((result) => {
        
        })
       
   }
               

  }

//   getplan() {
//     setTimeout(() => {
//        //ภายใน
//         Axios.get('https://git.kpru.ac.th/FrontEnd_creditbank/index/searchplan/'+this.props.Curriculumopen_ID)
//        .then(res => {
//          console.log(res);
//        //  this.setState({ bankname: res.data, loading: false })
//          this.setState({ plan: res.data})
//        }) 
//      }, 0);
//   }

  componentDidMount() {

    //const { id_send } = this.props.id_send
    //console.log(this.props.Curriculumopen_ID);
    this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
   
  
    api.get('index/getCurriculumdetal/'+this.props.Curriculumopen_ID,
    //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
              {headers: {
              // Authorization: 'Bearer ' + localStorage.getItem('myData')
              }
              })
             
              .then(res => {
              // console.log(res.data[0].id)
            
              this.setState({ Curriculumopen_ID : res.data[0].Curriculumopen_ID });
              this.setState({ Course_ID : res.data[0].Course_ID });
              this.setState({ Course_YEAR : res.data[0].Course_YEAR });
              this.setState({ Curriculumopen_TEAM : res.data[0].Curriculumopen_TEAM });
              this.setState({ Curriculumopen_Full_Name_TH : res.data[0].Curriculumopen_Full_Name_TH });
              this.setState({ Curriculumopen_Full_Name_EN : res.data[0].Curriculumopen_Full_Name_EN });
              this.setState({ Curriculumopen_Detail_TH : res.data[0].Curriculumopen_Detail_TH });
              this.setState({ Curriculumopen_Detail_EN : res.data[0].Curriculumopen_Detail_EN });
              this.setState({ Curriculumopen_CH : res.data[0].Curriculumopen_CH });
              this.setState({ Curriculumopen_Date_START : res.data[0].Curriculumopen_Date_START });
              this.setState({ Curriculumopen_Date_END : res.data[0].Curriculumopen_Date_END });
              this.setState({ Univ_ID : res.data[0].Univ_ID });
              
              //    const Curriculumopen = res.data;
               //   this.setState({ Curriculumopen });
       }) 
      // this.getplan();
    }
  

    render() {
        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="warning" ><MDBIcon icon="times" /> ไม่อนุมัติ</MDBBtn>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                        <MDBModalHeader toggle={this.toggle}>ไม่อนุมัติหลักสูตร</MDBModalHeader>
                        <MDBModalBody>
                        <p className="text-center">  <MDBIcon icon="times-circle" className="red-text pr-3" size="5x" /></p>
                        <h3>หลักสูตร {this.state.Curriculumopen_Full_Name_TH}</h3>


                        <div className="form-group">
                            <label htmlFor="example2">ข้อเสนอแนะ/คำแนะนำ</label>
                            <input
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            placeholder="ข้อเสนอแนะ/คำแนะนำ"
                            value={this.state.comment} onChange={this.handleChangnot} 
                            rows="5"
                            />
                        </div>

                       <p className="text-center"><MDBBtn color="deep-orange" onClick={this.updatenotApprove}>ยันยันไม่ผ่านพิจารณา</MDBBtn></p> 

                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
